import { useMemo } from "react";
import { useFliptBoolean } from "@flipt-io/flipt-client-react";

import { env } from "~/env";
import { useOrganizations, useSession } from "~/utils/auth";

export function useFeatureFlagBoolean(
  key: string,
  fallback: boolean,
  context?: Record<string, string>,
) {
  const organizations = useOrganizations();
  const organizationIds = useMemo(
    () => organizations.map((o) => o.id).join(","),
    [organizations],
  );
  const session = useSession();

  return useFliptBoolean(key, fallback, session.data?.user.id ?? "anonymous", {
    ...context,
    organization_ids: organizationIds,
    dev_mode: env.NODE_ENV === "development" ? "true" : "false",
  });
}
